import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { StripeService } from 'src/app/services/stripe.service';
import { AuthService } from 'src/services/auth/auth.service';
import * as env from './../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { EnvironmentService } from 'src/app/services/environment.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';

@Component({
  selector: 'settings-for-prefund-pro-upsell',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatProgressSpinner,
    CommonModule,
    MatRadioModule,
    FormsModule,
  ],
  templateUrl: './settings-for-prefund-pro-upsell.component.html',
  styleUrl: './settings-for-prefund-pro-upsell.component.scss',
})
export class SettingsForPrefundProUpsellComponent {
  isLoading = false;
  interval: 'month' | 'year' = 'month';

  constructor(
    public authService: AuthService,
    private stripeService: StripeService,
    private _matSnackBar: MatSnackBar,
    public environment: EnvironmentService,
    private logger: AnalyticsLoggerService
  ) {}

  async checkout(interval: 'month' | 'year') {
    if (!this.authService.user?.emailVerified) {
      this._matSnackBar.open('Please verify your email first');
      return;
    }

    if (!!this.authService.user?.uid) {
      this.isLoading = true;
      try {
        this.logger.logEvent(GENERAL_EVENTS.userCheckout);
        await this.stripeService.checkout(this.authService.user.uid, interval);
      } catch (e) {
        this.logger.logEvent(GENERAL_EVENTS.userCheckoutFailed);
        this._matSnackBar.open('Unexpected error');
        this.isLoading = false;
      }
    }
  }
}
